import { render } from "./AddNoteAction.vue?vue&type=template&id=5115da24&scoped=true"
import script from "./AddNoteAction.vue?vue&type=script&lang=js"
export * from "./AddNoteAction.vue?vue&type=script&lang=js"

import "./AddNoteAction.vue?vue&type=style&index=0&id=5115da24&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5115da24"]])

export default __exports__